export var LogLevels;
(function (LogLevels) {
    /** everything is logged */
    LogLevels["on"] = "on";
    LogLevels["debug"] = "debug";
    LogLevels["info"] = "info";
    LogLevels["log"] = "log";
    LogLevels["warn"] = "warn";
    LogLevels["error"] = "error";
    /** nothing is logged */
    LogLevels["off"] = "off";
})(LogLevels || (LogLevels = {}));
const levelSetting = {
    // everything is logged
    on: 100,
    // methods in order
    debug: 50,
    info: 40,
    log: 30,
    warn: 20,
    error: 10,
    // nothing is logged
    off: 0,
};
function doNothing() {
    // nothing
}
function isEnabled(method, logLevel) {
    return levelSetting[method] <= levelSetting[logLevel];
}
/**
 * Utility for preventing log spam
 */
export class ConsoleLogger {
    /**
     * Note
     * - the `defaultLevel` is overridden by the setting in localStorage
     * @param name
     * @param defaultLevel This is the default level
     */
    constructor(name, defaultLevel = LogLevels.error) {
        const loggerKey = `logger:${name}`;
        let levelSetting = localStorage.getItem(loggerKey);
        if (!levelSetting) {
            localStorage.setItem(loggerKey, defaultLevel);
            levelSetting = defaultLevel;
        }
        this.level = levelSetting;
    }
    get debug() {
        if (isEnabled("debug", this.level)) {
            return console.debug;
        }
        else {
            return doNothing;
        }
    }
    get info() {
        if (isEnabled("info", this.level)) {
            return console.info;
        }
        else {
            return doNothing;
        }
    }
    get log() {
        if (isEnabled("log", this.level)) {
            return console.log;
        }
        else {
            return doNothing;
        }
    }
    get warn() {
        if (isEnabled("warn", this.level)) {
            return console.warn;
        }
        else {
            return doNothing;
        }
    }
    get error() {
        if (isEnabled("error", this.level)) {
            return console.error;
        }
        else {
            return doNothing;
        }
    }
}
//# sourceMappingURL=ConsoleLogger.js.map